import { render, staticRenderFns } from "./ButtonUnassignPatient.vue?vue&type=template&id=9d6a0e66&"
import script from "./ButtonUnassignPatient.vue?vue&type=script&lang=js&"
export * from "./ButtonUnassignPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports